import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'

const Row = ({ amount = 0, interest = 0, rate, blendedRange }) => (
  <div>
    <div>
      <div className="tiers-column column">
        <ul>
          <li>
            <NumberFormat
              thousandSeparator={true}
              prefix={'$'}
              displayType={'text'}
              value={amount}
            />
          </li>
        </ul>
      </div>
      <div className="rate-column column">
        <ul>
          <li>
            <NumberFormat
              decimalScale={2}
              fixedDecimalScale={true}
              suffix={'%'}
              displayType={'text'}
              value={rate}
            />
          </li>
        </ul>
      </div>
      <div className="blended-column column">
        <ul>
          <li>{blendedRange}</li>
        </ul>
      </div>
      <br style={{ clear: 'both' }} />
    </div>
  </div>
)

Row.propTypes = {
  amount: PropTypes.number,
  interest: PropTypes.number,
  rate: PropTypes.number,
  blendedRange: PropTypes.string,
}

export default Row



// WEBPACK FOOTER //
// ./src/components/Row.js